import { get, put, post } from '@nbx/frontend-helpers/fetch-api';
import { context } from '@nbx/frontend-helpers/auth';

let baseUrl = 'users';

const NBXUsers = {
  init: config => ({ baseUrl } = config),

  getPreferences: () => context.user().then(user => get(`${baseUrl}/users/${user.id}/preferences`, user)),

  getProfile: () => context.user().then(user => get(`${baseUrl}/users/${user.id}`, user)),

  getDeclarations: () => context.user().then(user => get(`${baseUrl}/users/${user.id}/declarations`, user)),

  updateDeclarations: data =>
    context.user().then(user => post(`${baseUrl}/users/${user.id}/declarations`, { json: data }, user)),

  updatePreferences: data =>
    context.user().then(user => put(`${baseUrl}/users/${user.id}/preferences`, { json: data }, user))
};

export default NBXUsers;
